import React from "react";
import { connect } from "react-redux";
import { Provider } from "react-redux";
import "./App.css";
import CreateRoutes from "./routes/CreateRoutes";
import { PersistGate } from "redux-persist/integration/react";
import { store, persistor } from "./redux/store";
import history from "./utils/history";
import LoadDropdwon from "./components/LoadDropdwon/LoadDropdwon";
import ErrorBoundary from "./components/ErrorBoundary/ErrorBoundary";

function App() {
  // check authorization
  if (localStorage.getItem("USER_INFO") === null) {
    history.push("/");
  }

  return (
    <Provider store={store}>
      <PersistGate persistor={persistor}>
        <div className="App">
          <ErrorBoundary>
            <LoadDropdwon />
            <CreateRoutes />
          </ErrorBoundary>
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
